import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import api from 'services/api/api';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const editResource = async body => {
	const response = await api.patch('/recurso', body);
	return response.data;
};

export const useEditResource = (body: any, id: number) => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();

	return useMutation(() => editResource(body), {
		onSuccess: () => {
			queryClient.invalidateQueries(['recurso-list']);
			queryClient.invalidateQueries(['resourceWithId', id]);
			history.goBack();
			toast({
				title: 'Atualizado com sucesso!',
				description: 'Recurso atualizado com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao atualizar recurso!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
